// extracted by mini-css-extract-plugin
export default {"r_l":"b07c4e3ec1 _60b4892efc","t":"_15dff963ab"};